import type { Pagination } from '@/services/types/api.types';

export const isSamePage = (pagination: Pagination | undefined, page: number, pageSize: number): boolean => {
  return pagination?.page === page && pagination?.rowsPerPage === pageSize;
};
